import { render, staticRenderFns } from "./TeamCalendar.vue?vue&type=template&id=2dd3ac10&scoped=true&"
import script from "./TeamCalendar.vue?vue&type=script&lang=js&"
export * from "./TeamCalendar.vue?vue&type=script&lang=js&"
import style0 from "./TeamCalendar.vue?vue&type=style&index=0&id=2dd3ac10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd3ac10",
  null
  
)

export default component.exports